import template from "./custom-field-number-editor-element.pug";
import { ViewModel } from "@/lib/vm/viewmodel";
import type { PureComputed } from "knockout";
import { observable } from "knockout";
import ko, { pureComputed } from "knockout";
import type { ComponentArgs } from "@/lib/components/common";
import type { EditorElementParams } from "../common/editor-element-template";
import type { TextFieldParams } from "@/lib/components/text-field/text-field";
import { TextFieldType } from "@/lib/components/text-field/text-field";

export type CustomFieldNumberEditorElementParams = {
   invalidInputMessage: PureComputed<string | null>;
   isDisabled: boolean;
   value: PureComputed<number | null>;
} & EditorElementParams<number | null>;

export class CustomFieldNumberEditorElement extends ViewModel {
   readonly invalidInputMessage: CustomFieldNumberEditorElementParams["invalidInputMessage"];
   readonly isDisabled: CustomFieldNumberEditorElementParams["isDisabled"];
   readonly onChange: CustomFieldNumberEditorElementParams["onChange"];
   readonly title: CustomFieldNumberEditorElementParams["title"];
   readonly value: CustomFieldNumberEditorElementParams["value"];

   readonly textFieldMediator = pureComputed<string | null>({
      read: () => this.value()?.toString() ?? null,
      write: (value) => {
         const val = value != null ? Number(value) : null;
         this.onChange(val == null || isNaN(val) ? null : val);
      },
   });

   private readonly textFieldParams: TextFieldParams;

   constructor({
      invalidInputMessage,
      isDisabled,
      onChange,
      title,
      value,
   }: CustomFieldNumberEditorElementParams) {
      super(template());

      this.invalidInputMessage = invalidInputMessage;
      this.isDisabled = isDisabled;
      this.onChange = onChange;
      this.title = title;
      this.value = value;

      this.textFieldParams = {
         isClearable: observable(isDisabled != true),
         isDisabled,
         type: TextFieldType.NUMBER,
         value: this.textFieldMediator,
      };
   }

   static factory(
      params: CustomFieldNumberEditorElementParams,
   ): ComponentArgs<CustomFieldNumberEditorElementParams> {
      return {
         name: "custom-field-number-editor-element",
         params,
      };
   }
}

ko.components.register("custom-field-number-editor-element", {
   viewModel: CustomFieldNumberEditorElement,
   template: template(),
   synchronous: true,
});
